import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Set } from 'immutable'
import classNames from 'classnames'
import { Selectable, SelectableProps } from '#src/components/Path/components/Selectable'

class PlainInputSelectable extends Component<SelectableProps> {
  // TODO @fguerra change this to the new context api: https://reactjs.org/docs/legacy-context.html
  public static contextTypes = {
    handleChange: PropTypes.func,
    multiple: PropTypes.bool,
    name: PropTypes.string,
    // @ts-ignore: this needs to be replaced with the new context api:
    // https://reactjs.org/docs/legacy-context.html
    values: PropTypes.instanceOf(Set)
  }

  public render() {
    const {
      id,
      value,
      className,
      classes,
      headline,
      body,
      icon,
      isSingleSelect,
      children,
      ...rest
    } = this.props
    const { values, name } = this.context
    const isSelected = values && values.has(value)

    let selectableClasses = className
    if (classes) {
      selectableClasses = classNames(className, classes.default, {
        [classes.selected ? classes.selected : '']: isSelected
      })
    }

    const selectableId = `${name}-${value}`.toLowerCase()

    return (
      <Selectable
        className={selectableClasses}
        id={selectableId}
        testId={selectableId}
        value={value}
        multiple={true}
        checked={isSelected}
        handleChange={() => this.context.handleChange(value)}
        {...rest}
      >
        {children}
      </Selectable>
    )
  }
}

export default PlainInputSelectable
